import React, { Fragment } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import './TheFooter.scss'
import { routes } from 'App'
import { STATIONS_TYPE } from 'constants/stationsList'
import companyInfo from 'constants/companyInfo'
import addKeyLocalStorage from 'helper/localStorage'
import Facebook from '../../assets/new-icons/facebook.png'
import Tiktok from '../../assets/new-icons/tiktok.png'
import ContactPhoneOrZalo from 'components/BasicComponent/ContactPhoneOrZalo'
import Youtube from '../../assets/new-icons/youtube.png'
import Zalo from '../../assets/new-icons/zalo.png'
import VisaIcon from '../../assets/payment/VISA.svg'
import MasterCardIcon from '../../assets/payment/MASTERCARD.svg'
import JCBIcon from '../../assets/payment/JCB.svg'
import AMEXIcon from '../../assets/payment/AMEX.svg'
import VNPAYIcon from '../../assets/payment/VNPAY.svg'
import ZALOPAYIcon from '../../assets/payment/ZALOPAY.svg'
import SHOPEEPAYIcon from '../../assets/payment/SHOPEEPAY.svg'
import NAPASIcon from '../../assets/payment/NAPAS.svg'
import KREDIVOIcon from '../../assets/payment/KREDIVO.svg'
import MOMOIcon from '../../assets/payment/MOMO.svg'
import FOXPAYIcon from '../../assets/payment/FOXPAY.svg'
import ALEPAYIcon from '../../assets/payment/ALEPAY.svg'
import MUADEEIcon from '../../assets/payment/MUADEE.svg'
import HOMEPAYIcon from '../../assets/payment/HOMEPAY.svg'
import APPLEPAYIcon from '../../assets/payment/APPLEPAY.svg'
import SAMSUNGPAYIcon from '../../assets/payment/SAMSUNGPAY.svg'
import GOOGLEPAYIcon from '../../assets/payment/GOOGLEPAY.svg'
import KNPIcon from '../../assets/payment/knp.svg'
import QRAppStore from '../../assets/new-icons/QRApp.jpg'
import BAppStore from '../../assets/new-icons/BApp.png'
import BCHPlay from '../../assets/new-icons/BCHPlay.png'
import QRCHPlay from '../../assets/new-icons/QRPlay.jpg'
import { SCHEDULE_TYPE } from 'constants/serviceOption'
import BoCongThuong from '../../assets/icons/bct2.png'
import { REACT_APP_URL_WEB_BAOHIEM } from 'constants/url'
import { REACT_APP_URL_WEB_MINIAPP_DATLICH } from 'constants/url'
import { useAppParamsContext } from 'contexts/AppParamsContext'

export const TheFooter = (props) => {
  const { t: translation } = useTranslation()
  let userData = JSON.parse(localStorage.getItem(addKeyLocalStorage('data')))
  const isUserLoggedIn = useSelector((state) => state?.authReducer?.isUserLoggedIn)
  const history = useHistory()
  const { isEmbeddedView } = useAppParamsContext()
  const isTamove = process.env.REACT_APP_THEME_NAME === 'TAMOVE'

  const LIST_POLICY =
    process.env.REACT_APP_THEME_NAME === 'TAMOVE'
      ? [
          {
            label: 'Chính Sách Bảo Vệ Dữ Liệu Cá Nhân',
            href: '/chinh-sach-bao-ve-du-lieu-ca-nhan'
          },
          {
            label: 'Điều Khoản Sử Dụng Dịch Vụ',
            href: '/dieu-khoan-su-dung-dich-vu'
          },
          {
            label: 'Chính Sách Cookie',
            href: '/chinh-sach-cookie'
          },
          {
            label: 'Chính Sách An Toàn Thông Tin',
            href: '/chinh-sach-an-toan-thong-tin'
          },
          {
            label: 'Chính Sách Giải Quyết Khiếu Nại Dữ Liệu',
            href: '/chinh-sach-giai-quyet-khieu-nai-du-lieu'
          },
          {
            label: 'Chính Sách Vận Chuyển Và Giao Nhận',
            href: '/chinh-sach-van-chuyen-va-giao-nhan'
          },
          {
            label: 'Thông Tin Về Các Phương Thức Thanh Toán',
            href: '/thong-tin-phuong-thuc-thanh-toan'
          }
        ]
      : [
          {
            label: translation('footer.shipment-policy'),
            href: '/shipment-policy'
          },
          {
            label: translation('footer.payment-policy'),
            href: '/payment-policy'
          },
          {
            label: translation('footer.inspection-policy'),
            href: '/inspection-policy'
          },
          {
            label: translation('footer.customer-payment-information-privacy-policy'),
            href: '/customer-payment-information-privacy-policy'
          },
          {
            label: translation('footer.return-policy'),
            href: '/return-policy'
          }
        ]

  const LIST_ABOUT_US = [
    // {
    //   label: translation('footer.activities-statute'),
    //   href: '/general-policy'
    // },
    {
      label: translation('footer.about-company'),
      href: '/introduce'
    },
    {
      label: translation('footer.contact-cooperation'),
      href: '/contact-cooperation'
    },
    {
      label: translation('footer.common-question'),
      href: '/instruction'
    }
    // {
    //   label: translation('footer.payment-method'),
    //   href: '/payment-method'
    // },
    // {
    //   label: translation('footer.complaint-handling'),
    //   href: '/complaint-handling'
    // },
  ]

  const LIST_CONTACT = [
    {
      label: companyInfo?.hotline,
      href: `tel:${companyInfo?.hotline}`
    },
    {
      header: translation('footer.complaint-feedback'),
      label: companyInfo?.phoneNumber ? companyInfo?.phoneNumber : 'Liên hệ qua Zalo',
      href: companyInfo?.phoneNumber ? `tel:${companyInfo?.phoneNumber}` : companyInfo?.zaloLink,
      isOpenLink: !companyInfo?.phoneNumber
    },
    {
      header: translation('footer.technical-support'),
      label: companyInfo?.phoneNumber ? companyInfo?.phoneNumber : 'Liên hệ qua Zalo',
      href: companyInfo?.phoneNumber ? `tel:${companyInfo?.phoneNumber}` : companyInfo?.zaloLink,
      isOpenLink: !companyInfo?.phoneNumber
    }
  ]
  const LIST_SOCIAL_NETWORK = [
    {
      icon: Facebook,
      href: companyInfo?.facebookLink
    },
    {
      icon: Zalo,
      href: companyInfo?.zaloLink
    },
    {
      icon: Tiktok,
      href: companyInfo?.tiktokLink
    },
    {
      icon: Youtube,
      href: companyInfo?.youtubeLink
    }
  ]

  const LIST_SERVICE_BTNS = [
    {
      label: 'Trung tâm đăng kiểm',
      link: `/stations?type=${STATIONS_TYPE.EXTERNAL}&name=Trung tâm đăng kiểm`
    },
    {
      label: translation('Rescue'),
      link: `/stations?type=${STATIONS_TYPE.HELPSERVICE}&name=cuuho`
    },
    {
      label: translation('footer.user-search.insurance'),
      link: `${REACT_APP_URL_WEB_BAOHIEM}?appUserId=${userData?.appUserId}&token=${userData?.token}`,
      isOpenLink: true
    },
    {
      label: translation('Transport-cooperatives'),
      link: `/stations?type=${STATIONS_TYPE.COOPERATIVE}&name=htx`
    },
    {
      label: translation('Buy-sell-cars'),
      link: `/stations?type=${STATIONS_TYPE.USED_VEHICLES_DEALERSHIP}&name=muabanxe`
    },
    {
      label: translation('footer.user-search.insurance-unit'),
      link: `/stations?type=${STATIONS_TYPE.INSURANCE}&name=DonviBH`
    },
    {
      label: 'Mua bán phụ tùng ô tô',
      link: `/stations?type=${STATIONS_TYPE.SPARE_PARTS_DEALERSHIP}&name=Mua bán phụ tùng ô tô`
    },
    {
      label: 'Bảo dưỡng <br> ô tô',
      link: `/stations?type=${STATIONS_TYPE.GARAGE}&name=Bảo dưỡng ô tô`
    },
    {
      label: 'Bãi giữ xe',
      link: `/stations?type=${STATIONS_TYPE.PARKING_LOT}&name=Bãi giữ xe`
    },
    {
      label: translation('Vehicle-renovation'),
      link: `/stations?type=${STATIONS_TYPE.VEHICLE_MODIFICATION}&name=caitao`
    },
    {
      label: 'Trường học lái xe',
      link: `/stations?type=${STATIONS_TYPE.DRIVING_SCHOOL}&name=Trường học lái xe`
    },
    {
      label: 'Dịch vụ lái xe hộ',
      link: `/stations?type=${STATIONS_TYPE.CHAUFFEUR_SERVICE}&name=Dịch vụ lái xe hộ`
    },
    {
      label: 'Tư vấn SX phụ tùng xe',
      link: `/stations?type=${STATIONS_TYPE.PARTS_MANUFACTURING_CONSULTANCY}&name=Tư vấn SX phụ tùng xe`
    },
    {
      label: 'Khám sức khỏe lái xe',
      link: `/stations?type=${STATIONS_TYPE.DRIVER_HEALTH}&name=Khám sức khỏe lái xe`
    },

    {
      label: 'Cộng đồng Review',
      link: 'https://www.facebook.com/groups/635594368726917',
      isOpenLink: true
    },
    {
      label: translation('BHTNDS'),
      link: '/check-vihcle?service=/gia-han-bao-hiem-tnds&redirect=0'
    },
    {
      label: translation('material-insurance'),
      link: `/check-vihcle?service=https://ttdk.partner.saladin.vn/bao-hiem-vat-chat-toan-dien-xe-oto&redirect=1&bhvc=1`
    },
    {
      label: translation('Buy-sell-cars'),
      link: `https://vucar.vn/ban-xe?utm_source=TTDK&utm_medium=Landing%20Page&utm_campaign=C2B_TTDK`,
      isOpenLink: true
    },
    {
      label: translation('customer-support'),
      link: companyInfo?.facebookLink,
      isOpenLink: true
    },
    {
      label: translation('shares-experiences'),
      link: 'https://www.facebook.com/groups/635594368726917',
      isOpenLink: true
    },
    {
      label: translation('Vehicle-valuation'),
      link: 'https://dinhgiaxe.ai.vn/',
      isOpenLink: true
    },
    {
      label: 'Đăng ký dán thẻ ePass',
      link: `${REACT_APP_URL_WEB_MINIAPP_DATLICH}/booking?apikey=abeec15b-092e-424e-b3ec-9166a33a1539&vntId=H%E1%BB%93%20Ch%C3%AD%20Minh&scheduleType=2`,
      isOpenLink: true
    },
    {
      label: translation('schedule-maintenance'),
      link: 'https://oga.datxe.com/dlbd/?apiKey=a7f4c2eb-057b-4596-b016-b386b49af723',
      isOpenLink: true
    },
    {
      label: 'Nộp hồ sơ xe mới',
      link: routes.booking.path,
      scheduleType: SCHEDULE_TYPE.REGISTER_NEW_VEHICLE
    },
    {
      label: 'Đăng kiểm xe định kỳ',
      link: routes.booking.path,
      scheduleType: SCHEDULE_TYPE.VEHICLE_INSPECTION
    },
    {
      label: 'Thay đổi thông tin xe',
      link: routes.booking.path,
      scheduleType: SCHEDULE_TYPE.CHANGE_REGISTATION
    },
    {
      label: 'Tư vấn bảo hiểm',
      link: routes.booking.path,
      scheduleType: SCHEDULE_TYPE.CONSULTANT_INSURANCE
    },
    {
      label: 'Tư vấn bảo dưỡng',
      link: routes.booking.path,
      scheduleType: SCHEDULE_TYPE.CONSULTANT_MAINTENANCE
    },
    {
      label: 'Tư vấn hoán cải',
      link: routes.booking.path,
      scheduleType: SCHEDULE_TYPE.CONSULTANT_RENOVATION
    },
    {
      label: translation('footer.user-search.criminal-consult'),
      link: '/kiemtraphatnguoi'
    }
    //{
    //  label: 'Gia hạn BH TNDS',
    //  link: `/gia-han-bao-hiem-tnds?title=ghbh`,
    //},
    //{
    //  label: translation('footer.user-search.vehicleInfo-consult'),
    //  link: `${process.env.REACT_APP_DEPLOY_URL}/kiemtraphatnguoi`,
    //},
  ]

  const LIST_PAYMENT_COMPANY = [
    VisaIcon,
    MasterCardIcon,
    JCBIcon,
    AMEXIcon,
    VNPAYIcon,
    ZALOPAYIcon,
    ...(process.env.REACT_APP_THEME_NAME === 'TAMOVE' ? [KNPIcon] : []),
    ...(process.env.REACT_APP_THEME_NAME === 'TTDK' ? [SHOPEEPAYIcon] : []),
    NAPASIcon,
    KREDIVOIcon,
    MOMOIcon,
    FOXPAYIcon,
    ALEPAYIcon,
    MUADEEIcon,
    HOMEPAYIcon,
    APPLEPAYIcon,
    SAMSUNGPAYIcon,
    GOOGLEPAYIcon
  ]

  const mapperListIncludeLink = (item) => {
    const isExternal = item.href && (item.href.startsWith('http') || item.href.startsWith('tel:'))
    return (
      <Fragment key={JSON.stringify(item)}>
        <span className="cursor-default" style={{ color: '#ccc' }}>
          {item.header}
        </span>
        <li key={item.label}>
          {isExternal ? (
            <a href={item.href} target={item.isOpenLink ? "_blank" : "_self"} rel="noopener noreferrer" className="d-flex flex-column">
              <span>{item.label}</span>
            </a>
          ) : (
            <Link to={item.href || ''} className="d-flex flex-column" target={item.isOpenLink ? "_blank" : "_self"}>
              <span>{item.label}</span>
            </Link>
          )}
        </li>
      </Fragment>
    )
  }
  const CONNECT_TTDK_BLOCK = {
    title: <span className="cursor-default">{translation('footer.connect-us', { TTDK: companyInfo?.shortName })}</span>,
    list: (
      <>
        <h3 className="widget-item-title cursor-default">{translation('footer.support-switchboard')}</h3>
        {LIST_CONTACT.map(mapperListIncludeLink)}
      </>
    ),
    social: (
      <div style={{ display: '-webkit-inline-box', gap: '15px', margin: '10px 0 24px' }}>
        {LIST_SOCIAL_NETWORK.map((item) => (
          <p className="d-flex" key={item.href}>
            <a target="_blank" rel="noopener noreferrer" href={item.href}>
              <img style={{ width: '40px', height: '40px', borderRadius: '50%' }} src={item.icon} alt="Social icon" />
            </a>
          </p>
        ))}
      </div>
    )
  }

  const LIST_FOOTER_METADATA = isTamove
    ? [
        [
          {
            title: null,
            list: (
              <>
                <li className="mb-2" style={{ marginTop: -40 }}>
                  <img src="/logoFull.png" alt={companyInfo.name} style={{ height: '54px', objectFit: 'contain' }} />
                </li>
                <li>
                  <span>
                    {translation('footer.companyInfo.taxId')}: {companyInfo.taxId}
                  </span>
                </li>
                <li>
                  <span>
                    {translation('footer.companyInfo.address')}: {companyInfo.address}
                  </span>
                </li>
                <li>
                  <span>
                    {translation('footer.companyInfo.director')}: {companyInfo.director}
                  </span>
                </li>
                <li>
                  <span>
                    {translation('footer.companyInfo.dateOfOperation')}: {companyInfo.dateOfOperation}
                  </span>
                </li>
                <li>
                  <span>
                    {translation('footer.companyInfo.businessLicense')}: {companyInfo.taxId}
                  </span>
                </li>

                <li>
                  <span>
                    {translation('footer.companyInfo.email')}: <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
                  </span>
                </li>
                <li>
                  <span>
                    {translation('footer.companyInfo.hotline')}:&nbsp;
                    <a href={`tel:${companyInfo.hotline || companyInfo.phoneNumber}`}>{companyInfo.hotline || companyInfo.phoneNumber}</a>
                  </span>
                </li>
              </>
            ),
            social: null
          }
        ],
        ...(isUserLoggedIn
          ? [
              [
                {
                  title: <span className="cursor-default">{translation('footer.about-us')}</span>,
                  list: LIST_ABOUT_US.map(mapperListIncludeLink)
                }
              ]
            ]
          : []),
        [
          {
            title: <span className="cursor-default">{translation('footer.policy')}</span>,
            list: LIST_POLICY.map(mapperListIncludeLink)
          }
        ],
        [
          {
            title: CONNECT_TTDK_BLOCK.title,
            list: (
              <div className="d-flex flex-column align-items-start">
                {/* TAMOVE: Đưa Kết nối với vào đây */}
                {CONNECT_TTDK_BLOCK.social}
                <h3 className="widget-title text-white ">
                  <span className="cursor-default">{translation('footer.payment-support')}</span>
                </h3>

                <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                  {LIST_PAYMENT_COMPANY.map((payment, id) => (
                    <img key={id} src={payment} alt={`payment-method-${id}`} height="30" style={{ objectFit: 'contain' }} />
                  ))}
                </div>
                <div className="mt-3">
                  <h4 className="widget-title text-white mb-2">
                    <span>{translation('footer.certificate')}</span>
                  </h4>
                  <a href={companyInfo?.bctLink} target="_blank" rel="noopener noreferrer">
                    <img width={150} src={BoCongThuong} alt="Đã thông báo Bộ Công Thương" />
                  </a>
                </div>
              </div>
            )
          }
        ]
      ]
    : [
        [CONNECT_TTDK_BLOCK],
        [
          {
            title: <span className="cursor-default">{translation('footer.about-us')}</span>,
            list: LIST_ABOUT_US.map(mapperListIncludeLink)
          }
        ],
        [
          {
            title: <span className="cursor-default">{translation('footer.policy')}</span>,
            list: LIST_POLICY.map(mapperListIncludeLink)
          }
        ],
        [
          {
            title: <span className="cursor-default">{translation('footer.payment-support')}</span>,
            list: (
              <div className="d-flex flex-column align-items-start">
                <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                  {LIST_PAYMENT_COMPANY.map((payment, id) => (
                    <img key={id} src={payment} alt={`payment-method-${id}`} height="30" style={{ objectFit: 'contain' }} />
                  ))}
                </div>
                {process.env.REACT_APP_THEME_NAME !== 'TAMOVE' && (
                  <div className="d-flex flex-column align-items-start">
                    <h4 className="widget-title text-white mb-2">
                      <span>{translation('footer.certificate')}</span>
                    </h4>
                    <a href={companyInfo?.bctLink} target="_blank" rel="noopener noreferrer">
                      <img width={150} src={BoCongThuong} alt="Đã thông báo Bộ Công Thương" />
                    </a>
                  </div>
                )}
              </div>
            )
          }
        ]
      ]

  const LIST_INFO_COMPANY = [
    {
      title: 'CHPlay',
      QR: QRCHPlay,
      button: BCHPlay
    },
    {
      title: 'AppStore',
      QR: QRAppStore,
      button: BAppStore
    }
  ]

  const handleChPlay = () => window.open('https://play.google.com/store/apps/details?id=com.ttdk', '_blank')
  const handleAppStore = () =>
    window.open('https://apps.apple.com/vn/app/ttdk-%C4%91%E1%BA%B7t-l%E1%BB%8Bch-%C4%91%C4%83ng-ki%E1%BB%83m/id1663487095?l=vi', '_blank')

  const handleClickOnBtn = (typeOfStore) => (typeOfStore === 'CHPlay' ? handleChPlay() : handleAppStore())

  const checkStepBooking = (element) => {
    if (element.scheduleType) {
      history.push({
        pathname: element?.link,
        state: { scheduleType: element?.scheduleType }
      })
    } else {
      return element?.isOpenLink ? window.open(element.link) : history.push(element.link)
    }
  }

  return (
    <>
      {/* {isEmbeddedView === '1' ? null : <div className="footer-mobile" />} */}
      {isEmbeddedView ? null : <div className="footer-mobile" />}
      <div className="footer">
        <div className="footer">
          <div className="secarea">
            <div className="container">
              {LIST_FOOTER_METADATA.map((_column, i) => {
                return (
                  <div className="one_fourth" key={i}>
                    <div className="widget-area">
                      {_column.map((_col) => {
                        return (
                          <aside className="widget" key={_col.title}>
                            <h3 className="widget-title">
                              <span>{_col.title}</span>
                            </h3>
                            <div className="execphpwidget">
                              <div className="store">{_col?.store}</div>
                              <div className="social">{_col?.social}</div>
                              <ul className="foolist">{_col.list}</ul>
                            </div>
                          </aside>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="copyrights">
          {process.env.REACT_APP_THEME_NAME !== 'TAMOVE' && (
            <div className="container">
              {LIST_INFO_COMPANY.map((_item) => (
                <div key={_item.QR} className={`d-flex flex-column ${_item.QR === QRAppStore ? 'mt-12px' : ''}`}>
                  <div className="mb-2">
                    <img src={_item.QR} width="145px" height="145px" className={_item.QR === QRAppStore ? 'QRApp' : 'QRPlay'} alt="QR Code" />
                  </div>
                  <div className="cursor-pointer" onClick={() => handleClickOnBtn(_item.title)}>
                    <img
                      src={_item.button}
                      width="170px"
                      height={_item.button === BAppStore ? '94px' : '70px'}
                      style={{ marginLeft: -12 }}
                      alt="App Button"
                    />
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="container mb-3 cursor-default">
            <div style={{ textAlign: 'center' }}>
              <p>{translation('footer.copyright.other-users-search')}:</p>
              <div className="d-inline">
                {LIST_SERVICE_BTNS.map((_item, id) => (
                  <Fragment key={id}>
                    <a
                      href={_item.isOpenLink ? 'javascript:void(0)' : _item.link}
                      className="d-inline p-1 cursor-pointer service-items"
                      onClick={() => checkStepBooking(_item)}>
                      <span>{_item.label.split('<br>').join('')}</span>
                    </a>
                    {id !== LIST_SERVICE_BTNS.length - 1 ? <span className="vertical-rule">|</span> : ''}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className="container d-flex flex-column cursor-default">
            <p className="d-inline" style={{ textAlign: 'center' }}>
              © {companyInfo.name} • {translation('footer.copyright.address')}: {companyInfo.address} •{' '}
              {translation('company', { taxId: companyInfo.taxId, time: companyInfo.lastUpdatedAt })}
            </p>
            <p className="d-inline" style={{ textAlign: 'center' }}>
              <ContactPhoneOrZalo label={translation('footer.copyright.phone-number')} /> • Email: {companyInfo.email} •{' '}
              {translation('footer.copyright.content-responsibility')}: {companyInfo.director}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
